<template>
  <v-container class="pa-0">
    <v-row>
      <v-col style="max-width: 54px;" class="pt-4">
        <v-icon :color="iconColor ? iconColor : 'primary'">
          {{ whyUs.icon ? whyUs.icon : 'mdi-arrow-right-circle'}}
        </v-icon>
      </v-col>
      <v-col style="max-width: 250px;">
        <p class="mb-0 fourth--text font-weight-light">
          <span :class="`title font-weight-medium ${titleColor ? titleColor : 'white'}--text`">
            {{ $t(`${whyUs.title}`) }}
          </span><br>
          <span class="fourth--text text--lighten-3">
            {{ $t(`${whyUs.desc}`) }}
          </span>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'whyUs',
  props: {
    whyUs: Object,
    titleColor: String,
    iconColor: String,
  },
};
</script>

<style scoped>

</style>
